import {request} from "../../../utils/apiUtils";
import {URL_API} from "../../../url.config";

let AddressController = {
    getAllWard: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/address/list-ward`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    getAllProvince: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/address/list-province`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    getAllDistrict: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/address/list-district`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    getAllRegion: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/address/list-region`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    getAllUnit: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/address/list-unit`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
};
export default AddressController
